module.exports = __webpack_public_path__ + "static/media/ico_card_512.0dcfce46.png";